
import {
GET_POLICIE,
GET_POLICIE_SUCCESS,

GET_POLICIES,
GET_POLICIES_API_ERROR,
GET_POLICIES_SUCCESS
}
from "./actionTypes.js";


export const getPolicies = params => {
    return {
        type: GET_POLICIES,
        payload: params,
    }
}

export const getPoliciesSuccess = data => {
    return {
        type: GET_POLICIES_SUCCESS,
        payload:  data 
    }
}

export const apigetPolicieError = error => {
    return {
        type: GET_POLICIES_API_ERROR,
        payload: { error },
    }
}


export const getPolicie = params => {
    return {
        type: GET_POLICIE,
        payload: params,
    }
}

export const getPolicieSuccess = data => {
    return {
        type: GET_POLICIE_SUCCESS,
        payload:  data 
    }
}


